<template>
  <div class="dashboard-block" style="margin:20px;">
    <notification-exporter></notification-exporter>
    <form method="GET">
      <h2>Notification Preview</h2>
      <div class="row row-clear-md-4">
        <div class="col-md-3">
          <div class="form-group ">

            <label class="control-label" for="user_type">User Type:</label>
            <div class="input-group">
              <select v-model="user_type" name="user_type" class="form-control">
                <option v-bind:key="index" v-for="(option, index) in user_options" :value="option">{{ option }}</option>
              </select>
            </div>
          </div>
        </div>

        <div class="col-md-3">
            <label class="control-label" for="template">Template:</label>
            <div class="input-group">
              <select v-model="template" name="template" class="form-control">
                <option v-bind:key="index" v-for="(option, index) in options" :value="option">{{ option }}</option>
              </select>
            </div>
        </div>

        <div class="col-md-6 clear">&nbsp;</div>

        <div class="col-md-3">
          <div class="form-group">
            <label class="control-label" for="user_id">User ID:</label>
            <div class="input-group">
              <input v-model="user_id" type="number" id="user_id" name="user_id" placeholder="User ID" class="form-control">
            </div>
          </div>
        </div>

        <div class="col-md-3">
          <div class="form-group">
            <label class="control-label" for="booking_id">Booking ID:</label>
            <div class="input-group">
              <input v-model="booking_id" type="number" id="booking_id" name="booking_id"  class="form-control" placeholder="Booking ID">
            </div>
          </div>
        </div>

        <div class="col-md-3">
          <div class="form-group">
            <label class="control-label" for="payment_id">Payment ID:</label>
            <div class="input-group">
              <input v-model="payment_id" type="number" id="payment_id" name="payment_id"  class="form-control" placeholder="Payment ID">
            </div>
          </div>
        </div>

        <div class="col-md-3">
          <div class="form-group">
            <label class="control-label" for="file_id">File ID:</label>
            <div class="input-group">
              <input v-model="file_id" type="number" id="file_id" name="file_id" class="form-control" placeholder="File ID">
            </div>
          </div>
        </div>

        <div class="col-md-3">
          <div class="form-group">
            <label class="control-label" for="message_id">Message ID:</label>
            <div class="input-group">
              <input v-model="message_id" type="number" id="message_id" name="message_id" class="form-control" placeholder="Message ID">
            </div>
          </div>
        </div>

        <div class="col-md-3">
          <div class="form-group">
            <label class="control-label" for="talent_id">Talent ID:</label>
            <div class="input-group">
              <input v-model="talent_id" type="number" id="talent_id" name="talent_id" class="form-control" placeholder="Talent ID">
            </div>
          </div>
        </div>

        <div class="col-md-3">
          <div class="form-group">
            <label class="control-label" for="endorsement_id">Endorsement ID:</label>
            <div class="input-group">
              <input v-model="endorsement_id" type="number" id="endorsement_id" name="endorsement_id" class="form-control" placeholder="Endorsement ID">
            </div>
          </div>
        </div>

        <div class="col-md-3">
          <div class="form-group">
            <label class="control-label" for="invoice_id">Invoice ID:</label>
            <div class="input-group">
              <input v-model="invoice_id" type="number" id="invoice_id" name="invoice_id" class="form-control" placeholder="Invoice ID">
            </div>
          </div>
        </div>

      </div><!-- End of row -->

      <div class="panel-footer">
        <ladda-button
          class="btn btn-sm btn-primary"
          type="submit"
          :click="handleAddManagerCallback">
          Preview Notification
        </ladda-button>
      </div>
      <div v-for="(methodData, methodName) in textMessageMap" :key="methodData.randomId">
        <div class="row m-t-lg"></div>
        <div class="col-md-1">
          <div class="flexibleItem" v-if="methodData.channelSwitchEnabled === true">
            <toggle-button
              v-on:change="toggleNotificationChannel(methodData.active, methodName, methodData.notificationName)"
              v-model="methodData.active"
              class="pull-right date_unconfirmed"
              :color="{ checked: brandPrimary, unchecked: '#b7b7b7' }"/>
          </div>
        </div>
        <div class="row row-clear-md-4">
          <div :name="methodName" v-html="methodData.html" ></div>
          <div v-for="item in methodData.data" :key="item.randomId">
            <TextContent
              :updatedValue="item.updatedValue"
              :updatedValueWithPlaceHolders="item.updatedValueWithPlaceHolders"
              :method="item.methodName"
              :textTemplateId="item.textTemplateId"
              :notificationName="item.notificationName"
              :messageKey="item.key">
            </TextContent>
          </div>
        </div>
      </div>
    </form>

    <div class="row row-clear-md-4">
      <div id="email-preview" v-html="emailContent" >
      </div>
    </div>
    <div v-if="emailParts">
      <div v-for="emailPart in emailParts" :key="emailPart.randomId">
        <NotificationContent
          :notificationOriginalContent="emailPart.originalContent"
          :notificationSavedContent="emailPart.savedContent"
          :partId="emailPart.id"
          :emailTemplate="emailTemplate"
          :notificationTemplateId="emailNotificationTemplateId">
        </NotificationContent>
      </div>
    </div>
  </div>
</template>

<script>
import { http, notify } from 'utils'
import { handleServerErrors } from 'utils/http'
import NotificationContent from './NotificationContent.vue'
import TextContent from './TextContent.vue'
import NotificationExporter from './NotificationExporter'

export default {
  props: [
    'defaultTemplate',
    'clientOptions',
    'managerOptions',
    'systemOptions',
    'user',
    'booking',
    'payment',
    'file',
    'message',
    'talent',
    'endorsement'
  ],
  components: {
    NotificationExporter,
    NotificationContent,
    TextContent
  },
  data () {
    return {
      user_type: null,
      template: null,
      user_id: null,
      booking_id: null,
      payment_id: null,
      file_id: null,
      message_id: null,
      talent_id: null,
      endorsement_id: null,
      htmlSections: [],
      emailParts: [],
      invoice_id: null,
      emailContent: '',
      textMessageMap: [],
      emailNotificationTemplateId: null,
      emailTemplate: null,
      options: [],
      user_options: [
        'Talent',
        'General',
        'Client',
        'System',
        'Manager',
        'Talent - Manager Copy'
      ]
    }
  },

  mounted () {
    this.template = this.defaultTemplate
    this.user_id = this.user
    this.booking_id = this.booking
    this.payment_id = this.payment
    this.file_id = this.file
    this.message_id = this.message
    this.talent_id = this.talent
    this.endorsement_id = this.endorsement
    this.invoice_id = this.invoice
  },

  watch: {
    user_type: function (val) {
      this.getOptions().then((response) => {
        this.options = response.data
        this.template = this.options[0]
      })
    }
  },

  methods: {
    handleAddManagerCallback () {
      return this.validate()
        .then(() => {
          const params = {
            user_type: this.user_type,
            template: this.template,
            user_id: this.user_id,
            booking_id: this.booking_id,
            payment_id: this.payment_id,
            file_id: this.file_id,
            message_id: this.message_id,
            talent_id: this.talent_id,
            endorsement_id: this.endorsement_id,
            invoice_id: this.invoice_id
          }

          return http.get(`email-preview`, { params })
        })
        .then((response) => {
          this.emailContent = response.data.mailView
          this.emailParts = Object.keys(response.data.mailReplaceable).map((k) => response.data.mailReplaceable[k])
          this.textMessageMap = response.data.textMessages
          this.emailNotificationTemplateId = response.data.mailTemplateId
          this.emailTemplate = response.data.mailTemplate
        }).catch((error) => {
          if (error.response && error.response.status === 422) {
            notify.error(error.response.data)
          } else {
            throw error
          }
        })
    },
    toggleNotificationChannel (channelStatus, method, notificationName) {
      const params = {
        channelStatus,
        method,
        notificationName
      }
      return http.post(`toggle-notification-status`, params).then((response) => {
        if (response.data === 1) {
          // TODO : handle success case
        } else {
          throw new Error('Error toggle notification')
        }
      }).catch((error) => {
        if (error.response && error.response.status === 422) {
          handleServerErrors(error, this.errors)
        } else {
          throw error
        }
      })
    },

    getOptions () {
      const params = { user_type: this.user_type }
      return http.get(`email-template`, { params })
    }
  }
}
</script>
